@if (showContent) {
<div class="admin-details">
  <div>
    @switch (selectedItem?.type) {
      @case (AdministrationItemType.Zone) {
          <app-zone-details
                              [detailsInitInfo]="selectedItem"
                              (cancel)="onDetailCancel()"
                              (zoneCreated)="onZoneCreated($event)"
                              (zoneUpdated)="onZoneUpdated($event)"
                              (zoneDeleted)="onZoneDeleted($event)"
                              (hasPendingDetailChangesChanged)="onHasPendingDetailChanges($event)"></app-zone-details>
      }
      @case (AdministrationItemType.ZoneDevice) {
        <app-zone-device-details
                              [detailsInitInfo]="selectedItem"
                              (cancel)="onDetailCancel()"
                              (deviceCreated)="onDeviceCreated($event)"
                              (deviceUpdated)="onDeviceUpdated($event)"
                              (deviceDeleted)="onDeviceDeleted($event)"
                              (hasPendingDetailChangesChanged)="onHasPendingDetailChanges($event)"></app-zone-device-details>
      }
      @case (AdministrationItemType.Tariff) {
        <app-tariff-details
                              [detailsInitInfo]="selectedItem"
                              (cancel)="onDetailCancel()"
                              (tariffCreated)="onTariffCreated($event)"
                              (tariffUpdated)="onTariffUpdated($event)"
                              (tariffDeleted)="onTariffDeleted($event)"
                              (hasPendingDetailChangesChanged)="onHasPendingDetailChanges($event)"></app-tariff-details>
      }
      @case (AdministrationItemType.Subscription) {
        <app-subscription-details
                              [detailsInitInfo]="selectedItem"
                              (cancel)="onDetailCancel()"
                              (subscriptionCreated)="onSubscriptionCreated($event)"
                              (subscriptionUpdated)="onSubscriptionUpdated($event)"
                              (subscriptionDeleted)="onSubscriptionDeleted($event)"
                              (hasPendingDetailChangesChanged)="onHasPendingDetailChanges($event)"></app-subscription-details>
      }
      @case (AdministrationItemType.ConfigBasedStructuralElement) {
        <app-structural-entry-details
                              [detailsInitInfo]="selectedItem"
                              (cancel)="onDetailCancel()"
                              (entryCreated)="onStructuralEntryCreated($event)"
                              (entryUpdated)="onStructuralEntryUpdated($event)"
                              (entryDeleted)="onStructuralEntryDeleted($event)"
                              (hasPendingDetailChangesChanged)="onHasPendingDetailChanges($event)"></app-structural-entry-details>
      }
      @default {
        <div></div>
      }
    }
  </div>
</div>
}

